<template>
    <div>
        <b-form-group label="Fecha Inicio Explotación" label-for="date_service_partial">
            <flat-pickr
                v-model="dateStart"
                class="form-control"
                name="date_service_partial"
                autocomplete="off"
                :disabled="disabled"
                :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y'}"
            />
            <small v-if="validation" class="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup} from 'bootstrap-vue'
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es'
import flatPickr from 'vue-flatpickr-component'

export default {
    components: {
        BFormGroup,
        flatPickr
    },
    props: {
        dateStart: {
            type: String,
            default: ''
        },
        validation: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            SpanishLocale,
            localDateStart: this.dateStart,
        }
    },
    watch: {
        dateStart(newVal) {
            this.localDateStart = newVal
            this.$emit('update', { start_date: this.localDateStart })
        },
    },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>